var textAlignCenter = {
  "textAlign": "center !important"
};

export { textAlignCenter };
